<!-- ===================== BANNER ===================== -->
<section class="hb">
	<div class="hb-fondo" #fondoBanner [class.hb-fondo--listo]="bannerListo"
		[style.background-image]="portada ? 'url(' + portada + ')' : null"></div>
	<div class="hb-sombra"></div>

	<div class="hb-contenido">
		<p class="hb-kicker">Sorteo Anáhuac · Boletos a la venta</p>
		<h1 class="hb-titulo">Entra a la casa<br>que puedes ganar.</h1>
		<p class="hb-texto">Recórrela cuarto por cuarto, como si ya estuvieras ahí. Un boleto te puede dar las llaves.</p>
		<div class="hb-acciones">
			<a class="hb-btn hb-btn--compra" [href]="urlCompra" target="_blank" rel="noopener">Compra tu boleto</a>
			<button type="button" class="hb-btn hb-btn--tour" (click)="abrirTour()" [disabled]="!casa">
				<span class="hb-btn__icono" aria-hidden="true"></span>Recorrer la casa
			</button>
		</div>
	</div>

	<p class="hb-nota">Foto 360° · prototipo con imágenes de muestra</p>
</section>

<!-- ===================== RECORRIDO (portada tipo Matterport) ===================== -->
<section class="hr" *ngIf="casa">
	<div class="hr-encabezado">
		<h2>Recorrido virtual</h2>
		<p>{{ casa.nombre }} · {{ casa.puntos.length }} espacios</p>
	</div>

	<button type="button" class="hr-portada" (click)="abrirTour()" [style.background-image]="'url(' + portada + ')'">
		<span class="hr-play" aria-hidden="true"></span>
		<span class="hr-portada__texto">Entrar a la casa</span>
	</button>

	<div class="hr-cuartos">
		<button type="button" *ngFor="let p of casa.puntos" (click)="abrirTour(p.id)">
			<span [style.background-image]="'url(' + carpeta + p.foto + ')'"></span>
			{{ p.titulo }}
		</button>
	</div>
</section>

<!-- ===================== RECORRIDO A PANTALLA COMPLETA ===================== -->
<div class="ht" *ngIf="tourAbierto" role="dialog" aria-modal="true" aria-label="Recorrido virtual">
	<div class="ht-lienzo" #lienzoTour></div>

	<div class="ht-cargando" *ngIf="!tourListo"><span></span></div>

	<header class="ht-barra">
		<div>
			<strong>{{ casa?.nombre }}</strong>
			<span *ngIf="punto">{{ punto.titulo }}</span>
		</div>
		<button type="button" class="ht-cerrar" (click)="cerrarTour()" aria-label="Salir del recorrido">✕</button>
	</header>

	<!-- plano: dónde estás -->
	<svg class="ht-plano" viewBox="0 0 100 108" aria-hidden="true" *ngIf="casa">
		<line *ngFor="let l of lineas" [attr.x1]="l[0]" [attr.y1]="l[1]" [attr.x2]="l[2]" [attr.y2]="l[3]" />
		<g *ngFor="let p of puntosPlano" class="ht-plano__punto" [class.on]="punto?.id === p.id" (click)="ir(p)">
			<circle [attr.cx]="p.plano![0]" [attr.cy]="p.plano![1]" r="5" />
		</g>
	</svg>

	<div class="ht-pista" *ngIf="pista && tourListo">
		<strong>Arrastra para mirar alrededor</strong>
		<span>Haz clic en los círculos del piso para caminar</span>
	</div>

	<nav class="ht-tira" *ngIf="casa">
		<button type="button" *ngFor="let p of casa.puntos" [class.on]="punto?.id === p.id" (click)="ir(p)">
			<span [style.background-image]="'url(' + carpeta + p.foto + ')'"></span>
			{{ p.titulo }}
		</button>
	</nav>

	<a class="ht-compra" [href]="urlCompra" target="_blank" rel="noopener">Compra tu boleto</a>
</div>
